import React from 'react';

interface IPainExcelProps {
  width?: number;
  height?: number;
}

export const PainExcel: React.FC<IPainExcelProps> = ({
  width = 48,
  height = 48,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="rotate(14 36 11)">
        <rect
          x="28"
          y="5"
          width="16"
          height="12"
          rx="2.5"
          fill="#F1FCEF"
          stroke="#4CAF50"
          strokeWidth="1.5"
        />
        <line
          x1="31"
          y1="10"
          x2="41"
          y2="10"
          stroke="#C9E9C2"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="31"
          y1="14"
          x2="37"
          y2="14"
          stroke="#C9E9C2"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>

      <g transform="rotate(-16 11 37)">
        <rect
          x="4"
          y="32"
          width="14"
          height="10"
          rx="2.5"
          fill="#F1FCEF"
          stroke="#4CAF50"
          strokeWidth="1.5"
        />
        <line
          x1="7"
          y1="36"
          x2="15"
          y2="36"
          stroke="#C9E9C2"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>

      <rect
        x="13"
        y="14"
        width="22"
        height="24"
        rx="3"
        fill="#F1FCEF"
        stroke="#4CAF50"
        strokeWidth="2"
      />

      <line
        x1="17"
        y1="22"
        x2="31"
        y2="22"
        stroke="#C9E9C2"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="17"
        y1="28"
        x2="27"
        y2="28"
        stroke="#C9E9C2"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="17"
        y1="34"
        x2="29"
        y2="34"
        stroke="#C9E9C2"
        strokeWidth="1.5"
        strokeLinecap="round"
      />

      <circle
        cx="24"
        cy="24"
        r="6"
        fill="white"
        stroke="#852525"
        strokeWidth="1.5"
      />
      <line
        x1="24"
        y1="21"
        x2="24"
        y2="23"
        stroke="#852525"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="24" cy="26" r="1.5" fill="#852525" />
    </svg>
  );
};
